import { _ as _extends } from './cc-he3fHS3P.js';

function transformShopifyImageToNextImage(value) {
    if (!value) {
        return null;
    }
    var _value_altText;
    const alt = (_value_altText = value.altText) != null ? _value_altText : "No alt text provided";
    delete value.altText;
    var _value_height, _value_id, _value_thumbhash, _value_width;
    return _extends({}, value, {
        alt,
        height: (_value_height = value.height) != null ? _value_height : undefined,
        id: (_value_id = value.id) != null ? _value_id : value.url,
        src: value.url,
        thumbhash: (_value_thumbhash = value.thumbhash) != null ? _value_thumbhash : undefined,
        width: (_value_width = value.width) != null ? _value_width : undefined
    });
}

export { transformShopifyImageToNextImage };
